import React from 'react';
import { TrippleLogo } from 'pages/components/LFHeader/LFHeader';
import { getMarketingSiteUrl } from 'utils';
import * as S from './Footer.styled';

function Footer() {
  return (
    <S.FooterContainer>
      <S.Inner>
        <S.Top>
          <S.Brand>
            <S.BrandRow>
              <TrippleLogo isHome showText={false} />
              <S.BrandName>Tripple</S.BrandName>
            </S.BrandRow>
            <S.BrandBlurb>
              One place for people, stock, money and daily work — free to start.
            </S.BrandBlurb>
            <S.Meta>
              <S.MetaItem href="mailto:founder@tripple-app.com">
                founder@tripple-app.com
              </S.MetaItem>
            </S.Meta>
          </S.Brand>

          <S.Nav>
            <S.NavLink href={getMarketingSiteUrl('/')} target="_blank" rel="noopener noreferrer">
              Home
            </S.NavLink>
            <S.NavLink href={getMarketingSiteUrl('/features')} target="_blank" rel="noopener noreferrer">
              Features
            </S.NavLink>
            <S.NavLink href={getMarketingSiteUrl('/contact')} target="_blank" rel="noopener noreferrer">
              Contact
            </S.NavLink>
            <S.NavRouterLink to="/signin">
              Sign in
            </S.NavRouterLink>
            <S.NavRouterLink to="/signup">
              Register
            </S.NavRouterLink>
          </S.Nav>
        </S.Top>

        <S.Bottom>
          <S.ByLine>By Tripple</S.ByLine>
          <S.Copy>{`Copyright © ${new Date().getFullYear()}`}</S.Copy>
        </S.Bottom>
      </S.Inner>
    </S.FooterContainer>
  );
}

export default Footer;
